import { _ as __assign } from './chunks/bundle-BXYHgzRj.js';
import React__default from 'react';
import { GroupChannelListProvider } from './GroupChannelList/context.js';
import { GroupChannelListUI } from './GroupChannelList/components/GroupChannelListUI.js';
import '@sendbird/chat/groupChannel';
import '@sendbird/uikit-tools';
import './useSendbirdStateContext.js';
import './withSendbird.js';
import './chunks/bundle-CfyvTsrV.js';
import './chunks/bundle-Bd7J49Pj.js';
import './chunks/bundle-CGbKAqtd.js';
import './utils/message/getOutgoingMessageState.js';
import './chunks/bundle-CXA05pe2.js';
import './chunks/bundle-DokyceKk.js';
import './chunks/bundle-Dz4_R08c.js';
import './chunks/bundle-u-vzK-oc.js';
import 'react-dom';
import './chunks/bundle-DWyboFhb.js';
import './chunks/bundle-CqMQE3-R.js';
import './chunks/bundle-DtujCCHB.js';
import './ui/IconButton.js';
import './ui/Button.js';
import './chunks/bundle-DNnUvjnZ.js';
import './ui/Icon.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import './chunks/bundle-ClfkSu0m.js';
import '@sendbird/chat/openChannel';
import './chunks/bundle-C4eUm39A.js';
import './chunks/bundle-CZybJwCN.js';
import './ui/SortByRow.js';
import './chunks/bundle-Buop2NT2.js';
import './chunks/bundle-B9zrKMRJ.js';
import './GroupChannelList/components/GroupChannelListHeader.js';
import './chunks/bundle-DGC3rWK4.js';
import './ui/ImageRenderer.js';
import './chunks/bundle-Dwpc_MJZ.js';
import './ui/Header.js';
import './ui/TextButton.js';
import './chunks/bundle-DmX77DTu.js';
import './EditUserProfile.js';
import './EditUserProfile/context.js';
import './EditUserProfile/components/EditUserProfileUI.js';
import './chunks/bundle-b7Foa0HG.js';
import './ui/Input.js';
import './ui/PlaceHolder.js';
import './ui/Loader.js';
import './chunks/bundle-Do-Uo0Mj.js';
import './chunks/bundle-Bf00X-bc.js';
import '@sendbird/chat/message';
import './chunks/bundle-Dh2SecIj.js';
import './GroupChannelList/components/GroupChannelPreviewAction.js';
import './GroupChannelList/components/GroupChannelListItem.js';
import './chunks/bundle-xuXUit3M.js';
import './chunks/bundle-Bytw3a1z.js';
import './chunks/bundle-CzzanD4i.js';
import './chunks/bundle-C12wpwcO.js';
import './chunks/bundle-BPRSyHcX.js';
import './chunks/bundle-Bdc0r0vX.js';
import './GroupChannel/components/TypingIndicator.js';
import './ui/Badge.js';
import './ui/ChannelAvatar.js';
import './chunks/bundle-ydxNdZ_o.js';
import './ui/MentionUserLabel.js';
import './chunks/bundle-BnRVAspH.js';
import './chunks/bundle-DsnagByW.js';
import './GroupChannelList/components/AddGroupChannel.js';
import './chunks/bundle-DKJYxqyB.js';
import './CreateChannel.js';
import './CreateChannel/components/CreateChannelUI.js';
import './chunks/bundle-CTIvAUPR.js';
import './sendbirdSelectors.js';
import './chunks/bundle-CeFR-WNJ.js';
import './CreateChannel/components/InviteUsers.js';
import './ui/UserListItem.js';
import './ui/MutedAvatarOverlay.js';
import './ui/Checkbox.js';
import './ui/UserProfile.js';
import './CreateChannel/components/SelectChannelType.js';

var GroupChannelList = function (props) {
    return (React__default.createElement(GroupChannelListProvider, __assign({}, props),
        React__default.createElement(GroupChannelListUI, __assign({}, props))));
};

export { GroupChannelList, GroupChannelList as default };
//# sourceMappingURL=GroupChannelList.js.map
